import React from "react";
import { PropTypes } from 'prop-types';
import './styles.scss';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import IconButton from "../others/IconButton";

import editButton from "./../../img/edit-inactive-button.svg";
import editButtonInverted from "./../../img/small-edit-button.svg";

import deleteButton from "./../../img/delete-inactive-button.svg";
import deleteButtonInverted from "./../../img/small-delete-button.svg";
import _ from './../../utils/ObjectUtils';
import { I18n } from 'react-redux-i18n';
import Checkbox from './../fields/checkboxes/Checkbox';

class DataTableHeader extends React.Component {
    constructor(props) {
        super();
        this.state = {
            visiblePages: this.getVisiblePages(props.pages, props.page)
        };
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.pages !== nextProps.pages || this.props.page !== nextProps.page) {
            this.setState({
                visiblePages: this.getVisiblePages(nextProps.pages, nextProps.page)
            });
        }
    }

    filterPages = (visiblePages, totalPages) => {
        return visiblePages.filter(page => page <= totalPages);
    };

    getVisiblePages = (total, page) => {
        const activePage = page + 1;
        if (total < 7) {
            return this.filterPages([1, 2, 3, 4, 5, 6], total);
        } else {
            if (activePage > 4 && activePage + 3 < total) {
                return [1, 0, activePage - 1, activePage, activePage + 1, 0, total];
            } else if (activePage > 4 && activePage + 3 >= total) {
                return [1, 0, total - 4, total - 3, total - 2, total - 1, total];
            } else {
                return [1, 2, 3, 4, 5, 0, total];
            }
        }
    };

    changePage(page) {
        const activePage = this.props.page;
        if (page === activePage) {
            return;
        }
        this.props.onPageChange(page);
    }

    buildPagination() {
        const { page, pages } = this.props;
        const { visiblePages } = this.state;

        const emptySearchResults = pages === 0;
        const currentPageIsLastPage = page + 1 === pages;
        const currentPageIsFirstPage = page === 0;

        return !emptySearchResults && (
            <>
                {currentPageIsFirstPage ?
                    <button className='data-table-header-arrow-button disabled' style={{ paddingLeft: '1.2rem' }}>
                        <FontAwesomeIcon icon={['fa', 'caret-left']} />
                    </button> :
                    <button onClick={() => this.changePage(page - 1)} className='data-table-header-arrow-button' style={{ paddingLeft: '1.2rem' }}>
                        <FontAwesomeIcon icon={['fa', 'caret-left']} />
                    </button>
                }
                {visiblePages.map((pageNumber, index) => {
                    return (
                        <button
                            key={index}
                            className={page === pageNumber - 1 ? 'data-table-header-current-page-button' : 'data-table-header-other-page-button'}
                            onClick={() => this.changePage(pageNumber - 1)}
                            disabled={pageNumber === 0}
                        >
                            {pageNumber === 0 ? '...' : pageNumber}
                        </button>
                    )
                })}
                {currentPageIsLastPage ?
                    <button className='data-table-header-arrow-button disabled'>
                        <FontAwesomeIcon icon={['fa', 'caret-right']} />
                    </button> :
                    <button onClick={() => this.changePage(page + 1)} className='data-table-header-arrow-button'>
                        <FontAwesomeIcon icon={['fa', 'caret-right']} />
                    </button>
                }
            </>
        )
    }

    render() {
        const {
            page,
            pages,
            pageSize,
            selectAll,
            hasRowSelector,
            toggleSelectAll,
            numberOfSelectableRows,
            totalElements,
            hasEdit = true,
            hasDelete = true,
            customMultiOptions,
            selectedEntries,
            numberOfSelectedEntries
        } = this.props;

        const firstItemNumber = page * pageSize + 1;
        const lastItemNumber = (page + 1) * pageSize;

        return (
            <div className='data-table-header' >
                {hasRowSelector && <div className="data-table-header-selected-and-buttons">
                    <div className="data-table-header-selected-items">
                        <Checkbox
                            className="checkbox"
                            checked={selectAll === 1}
                            onChange={toggleSelectAll}
                            disabled={totalElements === 0 || numberOfSelectableRows === 0}
                            isIndeterminate={selectAll === 2}
                        />
                        <span className="entries-number">{I18n.t('dataTable.header.numberOfSelectedEntries', { numberOfSelectedEntries })}</span>
                    </div>
                    <div>
                        {hasEdit && <IconButton
                            alt="edit"
                            classes="data-table-header-button"
                            selected={false}
                            // handleIconClick={(e) => this.toggleFilterBoxExpanded(e.target.value)}
                            image={editButton}
                            disabled={!(numberOfSelectedEntries > 0)}
                            invertedImage={numberOfSelectedEntries > 0 ? editButtonInverted : null}
                        />
                        }
                        {hasDelete && <IconButton
                            alt="delete"
                            classes="data-table-header-button"
                            selected={false}
                            // handleIconClick={(e) => this.toggleFilterBoxExpanded(e.target.value)}
                            image={deleteButton}
                            disabled={!(numberOfSelectedEntries > 0)}
                            invertedImage={numberOfSelectedEntries > 0 ? deleteButtonInverted : null}
                        />}
                        {customMultiOptions && customMultiOptions.map((customOption, optionIndex) => {
                            return <span key={"customOption-" + optionIndex}>
                                {customOption(selectedEntries, numberOfSelectedEntries)}
                            </span>
                        })}
                    </div>
                </div>
                }
                {
                    !_.isNilOrEmpty(totalElements) && (
                        <div className="data-table-header-paging">
                            {totalElements >= pageSize && totalElements !== 0 ?
                                page + 1 === pages ?
                                    I18n.t("dataTable.header.numberOfElements.itemsRangeAndTotal", { firstItemNumber, totalElements, lastItemNumber: totalElements }) :
                                    I18n.t("dataTable.header.numberOfElements.itemsRangeAndTotal", { firstItemNumber, totalElements, lastItemNumber })
                                : totalElements === 1 ?
                                    I18n.t("dataTable.header.numberOfElements.singleItem") :
                                    I18n.t("dataTable.header.numberOfElements.singlePage", { totalElements })
                            }
                            {
                                page === 0 && pages - 1 === page ?
                                    null :
                                    this.buildPagination()
                            }
                        </div>
                    )
                }
            </div>
        );
    }
}

DataTableHeader.propTypes = {
    pages: PropTypes.number.isRequired,
    page: PropTypes.number.isRequired,
    totalElements: PropTypes.number,
    selectedEntries: PropTypes.object,
    numberOfSelectedEntries: PropTypes.number,
    pageSizeOptions: PropTypes.array.isRequired,
    onPageChange: PropTypes.func,
    onPageSizeChange: PropTypes.func,
    hasEdit: PropTypes.bool,
    hasDelete: PropTypes.bool,
    customMultiOptions: PropTypes.array
};

export default DataTableHeader; 